import { render, staticRenderFns } from "./TFContact.vue?vue&type=template&id=114c7f82&scoped=true&"
import script from "./TFContact.vue?vue&type=script&lang=js&"
export * from "./TFContact.vue?vue&type=script&lang=js&"
import style0 from "./TFContact.vue?vue&type=style&index=0&id=114c7f82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114c7f82",
  null
  
)

export default component.exports